import {graphql} from 'gatsby'
import React from 'react'

import {PricingSection} from '@/sections/pricing'

import type {PricingSliceFragment} from '@/graphql-types'

type Props = {
    slice: PricingSliceFragment
}

export const PricingSlice = ({slice}: Props) => (
    <PricingSection title={slice.primary.pricingTitle?.richText} />
)

export const pricingSliceFragment = graphql`
    fragment PricingSlice on PrismicSlicePageDataBodyPricing {
        __typename
        primary {
            pricingTitle: title {
                richText
            }
        }
    }
`
